export const HashRouterPidList = ["cn_cone_iCih7b", "cn_cone_2h3Gpr", "cn_cone_rNsaPK", "cn_cone_GXMcky", "cn_cone_hr_atm"];  // 使用hash路由的pid集合

export const CnWorkNoList = ['cn_cone_XEdw8F'];
